export default {"src":"/_next/static/media/chevron_right.458e1fc1.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};